/**
 * GuardDashboard — Tableau de bord Services de Garde
 * Affiche les statistiques: nb établissements, gardes actives, zones
 */
import { Card, CardContent, Typography, Grid, Box, Chip } from '@mui/material';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MapIcon from '@mui/icons-material/Map';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const green = '#1B5E3B';

const statCards = [
  {
    title: 'Établissements enregistrés',
    value: '—',
    subtitle: 'Profils santé actifs',
    icon: <LocalPharmacyIcon sx={{ fontSize: 32, color: green }} />,
    color: '#E8F5E9',
  },
  {
    title: 'Gardes actives maintenant',
    value: '—',
    subtitle: 'Établissements de garde en ce moment',
    icon: <AccessTimeIcon sx={{ fontSize: 32, color: '#E74C3C' }} />,
    color: '#FFEBEE',
  },
  {
    title: 'Zones de garde',
    value: '—',
    subtitle: 'Zones géographiques configurées',
    icon: <MapIcon sx={{ fontSize: 32, color: '#1976D2' }} />,
    color: '#E3F2FD',
  },
  {
    title: 'Cliniques',
    value: '—',
    subtitle: 'Cliniques et hôpitaux',
    icon: <LocalHospitalIcon sx={{ fontSize: 32, color: '#7C4DFF' }} />,
    color: '#EDE7F6',
  },
];

export function GuardDashboard() {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="h5" fontWeight={700} color={green}>
          🏥 Services de Garde
        </Typography>
        <Chip label="MVP" size="small" sx={{ background: green, color: '#fff', fontWeight: 700 }} />
      </Box>

      <Grid container spacing={3}>
        {statCards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.title}>
            <Card
              elevation={0}
              sx={{
                border: '1.5px solid #F0ECE6',
                borderRadius: 3,
                background: card.color,
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                  {card.icon}
                  <Typography variant="h4" fontWeight={800} color={green}>
                    {card.value}
                  </Typography>
                </Box>
                <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.subtitle}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4, p: 3, background: '#F5F5F5', borderRadius: 3 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          📋 Actions rapides
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Chip
            label="📍 Créer une zone de garde"
            clickable
            onClick={() => window.location.hash = '#/guard-zones/create'}
            sx={{ background: green, color: '#fff', fontWeight: 600 }}
          />
          <Chip
            label="📥 Importer un planning"
            clickable
            onClick={() => window.location.hash = '#/guard-import'}
            sx={{ background: '#1976D2', color: '#fff', fontWeight: 600 }}
          />
        </Box>
      </Box>
    </Box>
  );
}
